import useStyles from '../../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import React, { useCallback, useContext } from 'react';
import {
  CalculatorContext, getOrderedOptions, TargetFieldCategory,
  TargetFieldContext,
  VariableContext,
} from '../../../../../../services/common/CalculatorUtils';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CalculatorSelectInput from '../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';

const TargetFieldDocumentTypeField = ({ fieldName, readOnly = false }) => {
  const { classes } = useStyles();

  const { documentTypes } = useContext(CalculatorContext);

  const { selectedTargetFieldCategory } = useContext(TargetFieldContext);

  const { onVariableChangeCallBack, currentVariable } = useContext(
    VariableContext
  );

  const formMethods = useFormContext();
  const { setValue, clearErrors, getValues } = formMethods;

  const clearIntermediateFields = useCallback((fromLevel) => {
    const current = getValues(fieldName) || {};

    Object.keys(current)
      .filter((k) => k.startsWith("intermediatefield-"))
      .map((k) => ({
        key: k,
        idx: Number(k.replace("intermediatefield-", "")),
        }))
      .filter(({ idx }) => Number.isFinite(idx) && idx > fromLevel)
      .forEach(({ key }) => {
        setValue(`${fieldName}.${key}`, undefined);
      });
  }, [fieldName, getValues, setValue]);

  const onTargetFieldDocumentTypeChange = useCallback(
(newValue) => {
         // On purge tout ce qui dépend du document_type_id (sinon chemin incohérent)
         setValue(`${fieldName}.field`, undefined);
         setValue(`${fieldName}.field_type`, undefined);
         setValue(`${fieldName}.field_sub_type`, undefined);
         setValue(`${fieldName}.inner_field`, undefined);
         setValue(`${fieldName}.complex_list_sub_field`, undefined);

         // purge des intermediatefields, sinon un ancien path peut rester valide
         clearIntermediateFields(-1);

         clearErrors([
            `${fieldName}.field`,
            `${fieldName}.field_type`,
            `${fieldName}.field_sub_type`,
            `${fieldName}.inner_field`,
            `${fieldName}.complex_list_sub_field`,
         ]);
        },
        [fieldName, setValue, clearErrors, clearIntermediateFields]
    );

  switch (selectedTargetFieldCategory) {
    case TargetFieldCategory.DOCUMENT:
      return (
        <>
          <div className={classes.variableDivider}> /</div>

          {!_.isEmpty(documentTypes) && (
            <CalculatorSelectInput
              fieldName={`${fieldName}.document_type_id`}
              label={``}
              isRequired
              placeholder={i18next.t(
                `calculator.dialog.create.placeholder.selectValue`
              )}
              options={getOrderedOptions(documentTypes)}
              onChange={(newValue) => {
                  onTargetFieldDocumentTypeChange(newValue);
                  onVariableChangeCallBack(currentVariable, 'document_type_id');
              }}
              validate={() => {
                return null;
              }}
              variant="standard"
              labelVariant="standard"
              className={classes.inputPathVariableItem}
              disabled={readOnly}
            />
          )}
        </>
      );

    default:
      return <></>;
  }
};

export default TargetFieldDocumentTypeField;